const DesignFacade = require('../../../facade/design/design');
const ImagesFactory = require('../../images');

module.exports = {
  sourceListener: null,
  colorListener: null,

  initialize: function (RestrictionsFactory) {
    _.bindAll(this, 'onNewColor', 'onNewSource');
    this.restrictionsFactory = RestrictionsFactory;
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
  },

  refresh: function (permissions) {
    const restrictions = JSON.parse(permissions.get('restrictions') || '{}');

    if (restrictions.images && restrictions.images.list) {
      this.sourceListener || this.addSourceListener(permissions);
    } else if (this.sourceListener) {
      this.removeSourceListener();
    }

    if (restrictions.colors && restrictions.colors.list) {
      this.colorListener || this.addColorListener(permissions);
    } else if (this.colorListener) {
      this.removeColorListener();
    }
  },

  removeSourceListener: function () {
    this.sourceListener = null;
    DesignFacade.off('background.update.source.loaded', this.onNewSource);
  },

  addSourceListener: function (permissions) {
    this.sourceListener = permissions;
    DesignFacade.on('background.update.source.loaded', this.onNewSource);
  },

  removeColorListener: function () {
    this.colorListener = null;
    DesignFacade.off('background.update.color', this.onNewColor);
  },

  addColorListener: function (permissions) {
    this.colorListener = permissions;
    DesignFacade.on('background.update.color', this.onNewColor);
  },

  onNewColor: function (options) {
    const color = options.color;
    const restrictions = JSON.parse(this.colorListener.get('restrictions') || '{}');

    if (restrictions.colors && restrictions.colors.list) {
      if (!_(restrictions.colors.list).contains(color)) {
        this.canvas.call('advice.show', 'color-restriction-applied');
        restrictions.colors.list.push(color);

        this.restrictionsFactory.setGlobalElementRestriction(
          'background', JSON.stringify(restrictions)
        );
      }
    } else if (this.colorListener) {
      this.removeSourceListener(elementId);
    }
  },

  onNewSource: function (options) {
    const url = ImagesFactory.getVersionUrl(options.source, 'thumb');
    const restrictions = JSON.parse(this.sourceListener.get('restrictions') || '{}');

    const originalUrl = options.just_added?.data?.source;

    if (restrictions.images && restrictions.images.list) {
      if (!restrictions.images.list.includes(url)) {
        if (originalUrl) {
          restrictions.images.list = restrictions.images.list.map((source) => source === originalUrl ? url : source);
        } else {
          this.canvas.call('advice.show', 'source-restriction-applied');
          restrictions.images.list.push(url);
        }

        this.restrictionsFactory.setGlobalElementRestriction(
          'background', JSON.stringify(restrictions)
        );
      }
    } else if (this.sourceListener) {
      this.removeSourceListener(elementId);
    }
  }
};
